/**
 * 英语（en）
 */

import enLocale from 'element-ui/lib/locale/lang/en'
import publish from './publish/en'
import personal from './personal/en'
import order from './order/en'
import customProduct from './customProduct/en'
import index from './index/en'
import message from './message/en'

import billing from './billing/en'
import commodity from './commodity/en'
import home from './home/en'
import components from './components/en'

import personalCenter from './personal-center/en'

export default {
  ...enLocale,
  currency: {
    product: 'Product',
    inStock: 'In-stock',
    myProduct: 'My Product',
    listings: 'Listings',
    myDesign: 'My Design',
    wishList: 'Favorite Item', // Wish List
    allOrder: 'All Orders',
    customOrdersTitle: 'Custom Orders',
    customOrders: 'Orders',
    customCads: 'CADs',
    customSamples: 'Samples',
    fabricLibrary: 'Fabric Library',
    customPrinting: 'Custom Printing',
    customButton: 'Button',
    billingStatement: 'Billing Statement',
    store: 'Store',
    RefundingOrder: 'Refunding Order',
    personalCenter: 'Personal Center',
    payment: 'Payment',
    coupons: 'Coupons',
    address: 'Address',
    accountSettings: 'Account Settings',
    API: 'API',
    logOut: 'Sign Out',
    cancel: 'Cancel',
    submit: 'Submit',
    selectAll: 'All',
    confirmOrder: 'Confirm Order',
    back: 'Back',
    sortBy: 'Sort by',
    newest: 'Newest',
    highestInventory: 'Highest Inventory',
    highestSales: 'Highest Sales',
    highestPrice: 'Highest Price',
    lowestPrice: 'Lowest Price',
    customProduct: 'Custom Product',
    home: 'Home',
    newIn: 'New In',
    deleteTip: 'Are you sure to delete the selected product?',
    delete: 'delete'
  },
  // 语言
  lang: {
    english: 'English',
    chinese: 'Chinese',
    spanish: 'Spanish',
    japanese: 'Japanese',
    portuguese: 'Portuguese',
    french: 'French',
    russian: 'Russian',
    arabic: 'Arabic',
    german: 'German',
    italian: 'Italian',
    vietnam: 'Vietnam',
    turkey: 'Turkey',
    korean: 'Korean',
    thai: 'Thai',
    dutch: 'Dutch',
    hebrew: 'Hebrew',
    indonesian: 'Indonesian'
  },

  // 苏子龙
  // 现货页面 inSrock
  inSrock: {
    category: 'Categories',
    search: 'Search',
    searchingFor: 'Separate multiple searches with commas or spaces',
    shippingFrom: 'Ship From',
    supplierRank: 'Supplier Rank',
    supplierRankA: 'A level suppliers: The total inventory per SPU is above 300, and per SKU is typically above 100.',
    supplierRankB: 'B level suppliers: The total inventory per SPU is above 150, and per SKU is typically above 50.',
    supplierRankC: 'C level suppliers: The total inventory per SPU is below 100, and per SKU is typically between 10 and 50.',
    fabric: 'Fabric',
    price: 'Price',
    inventory: 'Inventory',
    newest: 'Newest',
    sales: 'Sales',
    min: 'Min',
    max: 'Max',
    recentSearches: 'Recent Searches',
    hotSearches: 'Hot Searches'
  },
  // 商品详情页
  productDetail: {
    product: 'Product',
    detail: 'Detail',
    itemNo: 'Item No',
    processingTime: 'Processing Time',
    shippingCost: 'Shipping Cost',
    paymentMethod: 'Payment Method',
    sizeGuide: 'Size Guide',
    color: 'Color',
    size: 'Size',
    viewAllVariants: 'View All Variants',
    allVariants: 'All Variants',
    shipFrom: 'Ship From',
    addToCart: 'Add To Bag',
    listToStore: 'List To Store',
    addToWishList: 'Add To Favorite Item', // Add To Wish List
    description: 'Description',
    return: 'Return',
    refundPolicy: 'Refund Policy',
    shipping: 'Shipping',
    image: 'Image',
    action: 'Action',
    // 选项卡/shipping
    packingSize: 'Packing Size',
    packingWeight: 'Packing Weight',
    shippingFrom: 'Shipping From',
    shippingTo: 'Shipping To',
    qty: 'Qty',
    maximum: 'Maximum inventory:',
    shippingMethod: 'Shipping Method',
    estimatedDeliveryTime: 'Estimated Delivery Time',
    sizeChart: 'Size Chart',
    deliveryTime: 'Delivery time',
    outOfStockTips: 'sorry, out of stock!',
    pleaseSelected: 'Please select',
    customerReviews: 'Customer Reviews',
    writeAReview: 'Write a review'
  },
  // 购物车
  shoppingCart: {
    selectAll: 'Select All',
    shoppingCart: 'Shopping Bag',
    topTip: 'Select products in same warehouse to put an order.'
  },
  // 确认订单
  confirmOrder: {
    shippingAddress: 'Shipping Address',
    addNewAddress: 'Add New Address',
    selectAnotherAddress: 'Select Another Address',
    editTheAddress: 'Edit The Address',
    remark: 'Notes',
    unitPrice: 'Unit Price',
    totalPayable: 'Order Amount',
    itemSubtotal: 'Item',
    subtotal: 'Subtotal',
    shippingSubtotal: 'Shipping Fee',
    promotion: 'Promotion',
    grandTotal: 'Total',
    creditCard: 'Credit Card',
    balance: 'Balance',
    payNow: 'Proceed to Checkout',
    commonProblem: 'Common Question',
    emailVerification: 'E-mail Verification',
    verificationTitle: 'A verification code has been sent to your mail',
    verification: 'Verification',
    seconds: 'seconds',
    laterGetPasswordAgain: 'later get password again',
    sendAgain: 'Send Again'
  },
  // 账号设置弹窗
  setting: {
    setting: 'Setting',
    fullName: 'FullName',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    notVerified: 'Not Verified',
    change: 'Change',
    codeSend: 'A verification code has been sent to your email',
    update: 'Update',
    updateName: 'Update Full name',
    UpdateEmail: 'Update Email',
    UpdatePhone: 'Update Mobile Phone',
    EmailSettings: 'Email Settings',
    Tips1: 'We’ve sent code to',
    Tips2: 'Password length 8-20 characters, and at least one uppercase letter, lowercase letter, number',
    Tips3: 'Please Add An Email Address To Ensure That Your Order Is Shipped Properly.',
    fullNamePlaceholder: 'please enter full name',
    emailPlaceholder: 'please enter email address',
    phonePlaceholder: 'please enter mobile phone',
    verificationCodePlaceholder: 'please enter verification code',
    passwordPlaceholder: 'please enter password'
  },
  // 张丰
  ...personal,

  // 孙泽严
  ...publish,
  ...order,
  ...customProduct,

  ...index,
  ...message,

  ...billing,
  ...commodity,
  ...home,
  ...personalCenter,
  ...components
}
